import React from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

export default function BaseButton({
  children,
  className,
  disabled,
  download,
  onClick,
  rawLink,
  rel,
  target,
  to,
  type,
  ...rawProps
}) {
  if (to) {
    if (rawLink) {
      const attrs = {
        className,
        href: to,
        rel,
        target
      };

      if (download) {
        attrs.download = download;
      }

      return (
        <a {...attrs} {...rawProps}>{ children }</a>
      );
    }

    return (
      <Link className={className} to={to} smooth {...rawProps}>
        { children }
      </Link>
    );
  }

  return (
    <button // eslint-disable-line react/button-has-type
      onClick={onClick}
      className={className}
      disabled={disabled}
      type={type}
      {...rawProps}
    >
      { children }
    </button>
  );
}

BaseButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  download: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onClick: PropTypes.func,
  rawLink: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top', '']),
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.object, // eslint-disable-line react/forbid-prop-types
      action: PropTypes.string,
      key: PropTypes.string
    })
  ]),
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
};

BaseButton.defaultProps = {
  className: '',
  disabled: false,
  download: false,
  onClick: () => {},
  rawLink: false,
  rel: '',
  target: '',
  to: '',
  type: 'button'
};
